import React from "react";

import svg from "../../assets/images/icons/Form Controls/slider.svg";

export const SliderIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Slider"}
    />
);
